module.exports = __webpack_public_path__ + "img/logo_dark.be3d9062.png";